import { sendGoogleEvent } from '@html/_common/utils';

export default function AOClpSeoDestinationLinks() {
  const EVENT_CATEGORY = 'Deals SEO Destination Link';
  const LINK_ITEM_CLASS_JS = '.js-clp-seo-destination-links__continent';

  this.initiate = () => {
    this.seoDestinationLinksTracking();
    this.headerDestinationTracking();
  };

  this.seoDestinationLinksTracking = () => {
    $('.js-ao-clp-seo-destination-links__country-link').on('click', (event) => {
      const $clickedElement = $(event.currentTarget);
      const clickedElementLink = $clickedElement.attr('href');
      const $continentsWrapper = $clickedElement.closest(LINK_ITEM_CLASS_JS);

      if (typeof clickedElementLink === typeof undefined || clickedElementLink === false) {
        return;
      }

      sendGoogleEvent(
        `${EVENT_CATEGORY} - destination links`,
        clickedElementLink,
        `Card: ${$continentsWrapper.index() + 1}; Item: ${$clickedElement.index() + 1}`,
      );
    });
  };

  this.headerDestinationTracking = () => {
    $('.js-clp-seo-destination-links__header-button').on('click', (event) => {
      const $clickedElement = $(event.currentTarget);
      const clickedElementLink = $clickedElement.attr('href');
      const clickedElementLabel = $clickedElement.text();
      const $continentsWrapper = $clickedElement.closest(LINK_ITEM_CLASS_JS);

      if (typeof clickedElementLink === typeof undefined || clickedElementLink === false) {
        return;
      }

      sendGoogleEvent(
        `${EVENT_CATEGORY} - destination links`,
        clickedElementLink,
        `Card: ${$continentsWrapper.index() + 1}; Item: Button - ${clickedElementLabel}`,
      );
    });
  };
}
